/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from "react";
import { Mary } from "@vwpfs/vwpfs-mary-react-comp-lib";
import { FormField } from "../../../07-organisms/Form/Field";
import { Field, FieldType } from "../../../../../store/Init/Types";
import { FormMaxLeaseLoanField, MaxLeaseLoanValidations } from "../../../../../store/MaxLeaseLoan/Types";
import { Required } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/components/core/05-atoms/Required";
import { ValidationStatus } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/components/core/07-organisms/Form/_Types";
import { mapFieldsForChange, setValidationPerField, validateFieldForChange } from "../../../../utils/Calc";
import debounce from "lodash.debounce";
import { FinancialLeaseValidations, FormFinancialLeaseObject, FormFinancialLeaseResponse } from "../../../../../store/StandAlone/Types";
import { FLParams } from "../../../../../store/RemoteTypes";
import { RangeSlider } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/components/core/05-atoms/RangeSlider";
import { formatOptions, shouldDisplayCurrencyDecimals } from "../../../../utils/FormatDisplays";
import { Summary } from "./Form/Summary";
import { WarningMessages } from "./Form/WarningMessages";
import { filterEditableFields } from "./Form/utils";
import { ErrorMessages } from "./Form/ErrorMessages";
import { SummarySubSection } from "./Form/SummarySubSection";

interface Props {
    result?: FormFinancialLeaseResponse;
    onChangeFormFields: (body: FormFinancialLeaseObject, params: FLParams, init?: boolean) => void;
    params: FLParams;
    loading: boolean;
}

/**
 *
 * @param props
 */
export const StandAloneForm: React.FC<Props> = ({ onChangeFormFields, result, params, loading }) => {
    const [store, setStore] = React.useState<{
        fields:  FormMaxLeaseLoanField[];
        validations: MaxLeaseLoanValidations;
        remoteRequest: ReturnType<typeof mapFieldsForChange>;
        remoteResult?: FormFinancialLeaseResponse;
    }>({
        fields: [],
        validations: {},
        remoteRequest: {},
        remoteResult: undefined,
    });
    const fields = result?.errors && store.remoteResult?.fields ? store.remoteResult?.fields : result?.formSchema?.fields;

    /**
     * @note We only use formfieldsFromRemoteOnlyMapped so we can see the differences later on to determine if we call the API or not
     * This will only map the response of the current API call.
     * @author Nick
     */
    const formfieldsFromRemoteOnlyMapped: FormMaxLeaseLoanField[] = result?.formSchema?.fields ? Object.entries(result?.formSchema?.fields).map(f =>
        ({
            id: f[0],
            field: {
                ...f[1],
                show:f[1].dependencies ? false : true,
            },
        })
    ) : [];

    const formfieldsMapped: FormMaxLeaseLoanField[] = fields ? Object.entries(fields).map(f => {
        const min = f[1].min === null ? store.fields.find(s => s.id === f[0])?.field.min : f[1].min;
        const max = f[1].max === null ? store.fields.find(s => s.id === f[0])?.field.max : f[1].max;
        /**
         * @note If a field is "active" which means the user is editing it, we wan't to keep using whatever the user is seeing in the field.
         * We don't want to update the value to whatever we get from the API response. Since this will cause odd behaviour.
         * We also need to make sure that the "active" state is retained.
         * @author Nick
         */
        const isActive = store.fields.find(s => s.id === f[0])?.field.active;
        return ({
            id: f[0],
            field: {
                ...f[1],
                min: min,
                max: max,
                value: isActive ? store.fields.find(s => s.id === f[0])?.field.value : f[1].value === null ? (min ?? 0) : f[1].value,
                show: f[1].dependencies ? false : true,
                active: isActive,
            },
        });
    }) : [];

    const initialValidations = formfieldsMapped?.reduce((acc, field) => {
        setValidationPerField({
            validations: acc as unknown as MaxLeaseLoanValidations,
            field: {
                value: field.field.value,
                type: field.field.fieldType,
                label: field.field.title,
                min: field.field.min,
                max: field.field.max,
                readonly: field.field.readonly,
            },
            fieldId: field.id,
        });
        return acc;
    }, {} as { [key: string]: any });

    React.useEffect(() => {
        if (result !== undefined && store.remoteResult !== result && (!result?.errors || !store.remoteResult?.fields)) {
            /**
             * @todo: store the differences between fields and the newly stored formFieldsMapped in the store, so we can read it out.
             * @author Nick
             */
            setStore({
                ...store,
                fields: formfieldsMapped,
                validations: initialValidations,
                remoteResult: result,
            });
        }
    }, [formfieldsMapped]);

    const updatedValues = (
        fields: FormMaxLeaseLoanField[],
        fieldId: string,
        field: {value: Field["value"]; type: Field["fieldType"]; label: Field["title"]; min?: Field["min"]; max?: Field["max"]; readonly?: Field["readonly"]}): FormMaxLeaseLoanField[] => (
        fields?.map(f => {
            const dependentValues = f.field.dependencies && Object.values(f.field.dependencies);
            if(fieldId === f.field.id) {
                return {
                    id: f.id,
                    field: {
                        ...f.field,
                        value: field.value,
                        active: true,
                    },
                };
            } else {
                return {
                    id: f.id,
                    field: {
                        ...f.field,
                        show: (f.field.dependencies && fieldId in f.field.dependencies
                            ? (dependentValues?.flat().includes(field.value) ? true : false) : f.field.show),
                        value: (f.field.dependencies && fieldId in f.field.dependencies
                            ? (dependentValues?.flat().includes(field.value) ? f.field.value : undefined) : f.field.value),
                        active: false,
                    },
                };
            }
        }).filter(f => f !== undefined))
    ;

    React.useEffect(() => {
        /**
         * @note We only trigger the API call whenever we are sure that the remoteRequest is not the same
         * We filter out only fields which are editable.
         * We use mapFieldsForChange for that, since we also would use this for the request to the API.
         * Besides that, it's an easy way to only look at the values which are different, because all other attributes of a field are not mapped.
         *
         * Also notice that we only look at fields which are shown and not readonly, since these are only fields the user can actually change.
         * @see filterEditableFields
         * @author Nick
         */
        const changedFormData = mapFieldsForChange(filterEditableFields<FormMaxLeaseLoanField>(store.fields));
        const changedFormFromPreviousResponse = mapFieldsForChange(filterEditableFields<FormMaxLeaseLoanField>(formfieldsFromRemoteOnlyMapped));

        if (Object.keys(changedFormData || {}).length > 0 && Object.keys(store.remoteRequest || {}).length <= 0) {
            /**
             * @note If there is no store.remoteRequest yet, since the very initial call is triggered from outside of the scope of the form.
             * We don't want to trigger the API again, but we do want to make sure we store the remoteRequest in the store.
             * So that later on whenever the user changes something, we can compare it against the previous request.
             * @author Nick
             */
            setStore(prevStore => ({
                ...prevStore,
                remoteRequest: changedFormData,
            }));
        } else {
            /**
             * @note
             * Determines whether an API call should be made based on form data changes.
             * The conditions ensure that:
             * 1. The form contains actual data (not empty)
             * 2. The new form data differs from the current store state
             * 3. The new form data differs from the previous API response
             *
             * This prevents:
             * - Unnecessary API calls when no data has changed
             * - Infinite loops from response-triggered updates
             * - API calls with empty form data
             *
             * @example
             * // Will trigger API call:
             * changedFormData = { amount: 200 }
             * store.remoteRequest = { amount: 100 }
             * changedFormFromPreviousResponse = { amount: 100 }
             *
             * // Won't trigger API call (no changes):
             * changedFormData = { amount: 100 }
             * store.remoteRequest = { amount: 100 }
             * changedFormFromPreviousResponse = { amount: 100 }
             * @author AI, Nick
             */
            if (
                Object.keys(changedFormData || {}).length > 0 &&
                JSON.stringify(store.remoteRequest) !== JSON.stringify(changedFormData)
                && JSON.stringify(changedFormData) !== JSON.stringify(changedFormFromPreviousResponse)
            ) {
                doApiCall();
            }
        }
    }, [store.fields, store.validations]);

    const onChange = (
        fieldId: string,
        field: {
            value: Field["value"];
            type: Field["fieldType"];
            label: Field["title"];
            min?: Field["min"];
            max?: Field["max"];
            step?: Field["step"];
            readonly?: Field["readonly"];
        }
    ) => {
        setStore({
            ...store,
            fields: updatedValues(store.fields, fieldId, field),
            /**
             * @note We need to be sure we are validating against what we are going to store, not what is in the store.
             * Previously we used store.fields directly and not look at the updated values.
             * @author Nick
             */
            validations: validateFieldForChange(updatedValues(store.fields, fieldId, field), store.validations ?? {}, fieldId, field),
        });
    };

    const onBlur = (
        fieldId: string,
    ) => {
        console.log("onBlur");
        setStore({
            ...store,
            /**
             * @note Everytime the users blurs from a field, we need to make sure that we mark the field as inactive.
             * This will make sure that after an API call the field get's updated accordingly by the API response.
             * @author Nick
             */
            fields: store.fields.map(f => f.id === fieldId ? {...f, field: {...f.field, active: false}} : f),
        });
    };


    const debouncedApiCall = React.useRef(
        debounce((props: {
            fields:  FormMaxLeaseLoanField[];
            validations:  {[key: string]: any};
            remoteResult?: FormFinancialLeaseResponse;
        }) => {
            /**
             * @note We only do a init calls whenever one of these core fields are changed.
             * Core fields that trigger initialization:
             * - financeType: Type of financing
             * - objectPriceInclVATInclBPM: Purchase price including VAT and BPM
             * - objectPriceExclVATInclBPM: Purchase price excluding VAT, including BPM
             *
             * The reason is that these fields are mandatory to be send to BLS on which we can determine the constraints for all the other fields, like min/max value etc.
             * @author AI, Nick
             */
            const isInit = !!props.fields.find(f => (f.id === "objectPriceInclVATInclBPM" || f.id === "objectPriceExclVATInclBPM" || f.id === "financeType") && f.field.active);
            const formData = mapFieldsForChange(props.fields);
            /**
             * @note We filter out only fields which are editable
             * @see filterEditableFields
             * @author Nick
             */
            const changedFormData = mapFieldsForChange(filterEditableFields(props.fields));
            setStore(prevStore => ({
                ...prevStore,
                remoteRequest: changedFormData,
            }));
            onChangeFormFields(formData, params, isInit);  // API call
        }, 500)
    ).current;

    const isDisabled = () => {
        /**
         * @note We want to disable the form (or in other words, prevent to call the API) whenever there are fields, which are not filled in correctly
         * In this case, we only check if there are fields which are in an error state.
         * @author Nick
         */
        const disabled = Object.entries(store.validations)?.filter(f => (store.fields.map(f => f.id).includes(f[0]))).some((s) => s[1]?.status === ValidationStatus.ERROR);
        return disabled;
    };

    const doApiCall = () => {
        if(!isDisabled()) {
            debouncedApiCall(store); // Trigger the debounced API call
        }
    };

    const hasValidationError = Object.keys(store.validations).some(
        (v) =>
            store.validations[v as keyof FinancialLeaseValidations]?.status ===
ValidationStatus.ERROR
    );

    const hasAnyError = hasValidationError || !!result?.errors;

    // const visibleFields = store.fields
    //     ?.filter(f => f.field.show)
    //     ?.filter(f => {
    //         const { fieldType, id } = f.field;
    //         if (fieldType === FieldType.SELECT && !(result?.financeTypeToggle || id !== "financeType")) {
    //             return false;
    //         }
    //         return true;
    //     }) || [];

    // const chunkArray = <T,>(array: T[], size: number): T[][] =>
    //     Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
    //         array.slice(i * size, i * size + size)
    //     );

    // const fieldPairs = chunkArray(visibleFields, 2);

    const visibleFields = store.fields?.filter(f => f.field.show) || [];

    const financeTypeField = visibleFields.find(f => f.field.id === "financeType");

    const otherFields = visibleFields.filter(f => f.field.id !== "financeType");

    function chunkArray<T>(array: T[], chunkSize: number): T[][] {
        const result: T[][] = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            result.push(array.slice(i, i + chunkSize));
        }
        return result;
    }

    const fieldPairs = chunkArray(otherFields, 2);

    return (
        <>
            {/* <LoadingOverlay loading={loading} /> */}
            <WarningMessages warnings={result?.warnings as Record<string, string>}/>
            <Mary.organisms.Form>
                {financeTypeField && !!result?.financeTypeToggle && (
                    <Mary.base.Div className="scl-b-row" key="financeType-row">
                        <Mary.base.Grid size={{ xs: 12, md: 6 }}>
                            <FormField
                                popperPlacement="bottom"
                                label={financeTypeField.field.title}
                                title={financeTypeField.field.description}
                                type={financeTypeField.field.fieldType}
                                placeholder={Mary.utils.getText("app.make-a-choice", "Make a choice")}
                                required={financeTypeField.field.required}
                                unsorted
                                value={financeTypeField.field.value as string}
                                options={formatOptions(financeTypeField.field.options)}
                                onChange={(value?: string | number) => {
                                    onChange(financeTypeField.field.id, {
                                        value: value?.toString() ?? "",
                                        type: financeTypeField.field.fieldType,
                                        label: financeTypeField.field.title,
                                        min: financeTypeField.field.min,
                                        max: financeTypeField.field.max,
                                        readonly: financeTypeField.field.readonly,
                                    });
                                }}
                                onBlur={() => onBlur(financeTypeField.field.id)}
                                validationFunction={
                                    financeTypeField.field.value !== undefined && store.validations?.[financeTypeField.field.id]
                                        ? () => store.validations?.[financeTypeField.field.id] as Mary.organisms.ValidationFeedback
                                        : undefined
                                }
                            />
                        </Mary.base.Grid>
                    </Mary.base.Div>
                )}
                {fieldPairs.map((pair, rowIndex) => (
                    <Mary.base.Div className="scl-b-row" key={`row-${rowIndex}`}>
                        {pair.map((f, i) => {
                            const key = `${f.id}-${rowIndex}-${i}`;

                            if (f.field.fieldType === FieldType.SELECT &&
          (!!result?.financeTypeToggle && f.field.id === "financeType" || f.field.id !== "financeType")) {
                                return (
                                    <Mary.base.Grid size={{ xs: 12, md: 6 }} key={key}>
                                        <FormField
                                            popperPlacement={(i === 0 || i === 1) ? "bottom" : "top"}
                                            label={f.field.title}
                                            title={f.field.description}
                                            type={f.field.fieldType}
                                            placeholder={Mary.utils.getText("app.make-a-choice", "Make a choice")}
                                            required={f.field.required}
                                            value={f.field.value as string}
                                            options={formatOptions(f.field.options)}
                                            onChange={(value?: string | number) => {
                                                onChange(f.field.id, {
                                                    value: value?.toString() ?? "",
                                                    type: f.field.fieldType,
                                                    label: f.field.title,
                                                    min: f.field.min,
                                                    max: f.field.max,
                                                    readonly: f.field.readonly,
                                                });
                                            }}
                                            onBlur={() => onBlur(f.field.id)}
                                            validationFunction={(f.field.value !== undefined && store.validations?.[f.field.id])
                                                ? () => store.validations[f.field.id] as Mary.organisms.ValidationFeedback : undefined}
                                        />
                                    </Mary.base.Grid>
                                );
                            }

                            if (f.field.fieldType === FieldType.CURRENCY) {
                                return (
                                    <Mary.base.Grid size={{ xs: 12, md: 6 }} key={key}>
                                        <FormField
                                            popperPlacement={(i === 0 || i === 1) ? "bottom" : "top"}
                                            label={f.field.title}
                                            title={f.field.description}
                                            type={f.field.fieldType}
                                            placeholder="e.g. 100"
                                            readonly={f.field.readonly}
                                            disabled={f.field.readonly}
                                            required={f.field.required}
                                            value={f.field.value as number}
                                            withPrefix
                                            /**
                                             * @note Right now we only check if we should display decimals whenever the number is a float or not.
                                             * We only do it for Currency and not range, since that would have other side effects
                                             * @author Nick
                                             */
                                            withoutDecimal={!shouldDisplayCurrencyDecimals(f.field.value)}
                                            onChange={(value?: string | number) => {
                                                const numericValue = Number(value);
                                                onChange(f.field.id, {
                                                    value: isNaN(numericValue) ? undefined : numericValue,
                                                    type: f.field.fieldType,
                                                    label: f.field.title,
                                                    min: f.field.min,
                                                    max: f.field.max,
                                                    readonly: f.field.readonly,
                                                });
                                            }}
                                            onBlur={() => onBlur(f.field.id)}
                                            validationFunction={(f.field.value !== undefined && store.validations[f.field.id])
                                                ? () => store.validations[f.field.id] as Mary.organisms.ValidationFeedback : undefined}
                                        />
                                    </Mary.base.Grid>
                                );
                            }

                            if (f.field.fieldType === FieldType.CURRENCY_RANGE) {
                                return (
                                    <Mary.base.Div className="scl-b-row" key={`${f.id}-${i}-currency-range`} style={{ display: "flex", alignItems: "center" }}>
                                        <Mary.base.Grid size={{ xs: 12, md: 6 }}>
                                            <FormField
                                                popperPlacement={(i === 0 || i === 1) ? "bottom" : "top"}
                                                label={f.field.title}
                                                title={f.field.description}
                                                type={f.field.fieldType}
                                                required={f.field.required}
                                                value={f.field.value as number}
                                                // min={f.field.min}
                                                // max={f.field.max}
                                                readonly={f.field.readonly}
                                                disabled={f.field.readonly}
                                                default={f.field.default}
                                                step={f.field.step}
                                                withPrefix={f.field.id === "duration" ? false : true}
                                                withoutDecimal
                                                onChange={(value?: string | number) => {
                                                    onChange(f.field.id, {
                                                        value: value ? typeof value === "string"
                                                            ? parseFloat(value) : value : 0,
                                                        type: f.field.fieldType,
                                                        label: f.field.title,
                                                        min: f.field.min,
                                                        max: f.field.max,
                                                        step: f.field.step,
                                                        readonly: f.field.readonly,
                                                    });
                                                }}
                                                onBlur={() => onBlur(f.field.id)}
                                                validationFunction={(f.field.value !== undefined && store.validations[f.field.id])
                                                    ? () => store.validations[f.field.id] as Mary.organisms.ValidationFeedback : undefined}
                                            />
                                        </Mary.base.Grid>
                                        <Mary.base.Grid size={{ xs: 12, md: 6 }} style={{ height: "44px" }}>
                                            <div className="scl-a-range-slider-wrapper">
                                                <RangeSlider
                                                    min={f.field.min}
                                                    max={f.field.max}
                                                    value={(f.field.value as number)}
                                                    step={f.field.step}
                                                    onChange={(newSliderValue: number) => {
                                                        onChange(f.field.id, {
                                                            value: newSliderValue,
                                                            type: f.field.fieldType,
                                                            label: f.field.title,
                                                            min: f.field.min,
                                                            max: f.field.max,
                                                            readonly: f.field.readonly,
                                                        });
                                                    }}
                                                    onMouseUp={() => onBlur(f.field.id)} />
                                            </div>
                                        </Mary.base.Grid>
                                    </Mary.base.Div>
                                );
                            }
                            return <React.Fragment key={`${key}-skipped`} />;
                        })}
                    </Mary.base.Div>
                ))}

                <div className="scl-h-text-align--right" style={{ marginBottom: "15px" }}>
                    <Required />
                </div>
            </Mary.organisms.Form>

            <ErrorMessages hasAnyError={hasAnyError} hasValidationError={hasValidationError} errors={result?.errors ?? undefined} validations={store.validations} />
            <SummarySubSection hasError={hasAnyError} loading={loading} result={result} />
            <Summary hasError={hasAnyError} loading={loading} result={result} />
        </>
    );
};


